import styles from "./datePickerTemplate/DatePickerTemplate.module.scss";
import Datepicker from "../../../../../Componnets/Datepicker/Datepicker";
import React, { useContext, useEffect, useState } from "react";
import Moment from "moment";
import appContext from "../../../../../../context/appContext";
import JalaliMoment from "jalali-moment";

const DatePickerTemplate = ({
                              type,
                              isOpen,
                              columnLayout,
                              handleSetPassedDate,
                              value,
                              whichDropdownIsOpen,
                              dropdownOpenPosition,
                            }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateToShow, setDateToShow] = useState(null);
  const [timeToShow, setTimeToShow] = useState(null);

  const isPersianCalendar = process.env.REACT_APP_CALENDAR_TYPE === "persian";

  const OUTPUT_FORMAT = "jYYYY-jMM-jDD HH:mm:ss";

  const JALALI_INPUT_FORMATS = [
    "jYYYY-jMM-jDD HH:mm:ss",
    "jYYYY-jMM-jDD HH:mm",
    "jYYYY-jMM-jDD",
    "jYYYY/jMM/jDD HH:mm:ss",
    "jYYYY/jMM/jDD HH:mm",
    "jYYYY/jMM/jDD",
  ];

  const handleToggleOpenDropdown = () => {
    whichDropdownIsOpen();
  };

  useEffect(() => {
    setIsDropdownOpen(isOpen);
  }, [isOpen]);

  const getValidJalaliMoment = (date) => {
    if (!date) return null;

    // اگر خود date یک moment object باشد
    if (typeof date === "object" && date._isAMomentObject) {
      const m = JalaliMoment(date);
      return m && m.isValid() ? m : null;
    }

    // اگر Date object باشد
    if (date instanceof Date) {
      const m = JalaliMoment(date);
      return m && m.isValid() ? m : null;
    }

    const dateString = String(date).trim();

    for (const format of JALALI_INPUT_FORMATS) {
      const m = JalaliMoment(dateString, format, true);
      if (m && m.isValid()) {
        return m;
      }
    }

    // fallback غیر strict
    const fallback = JalaliMoment(dateString);
    return fallback && fallback.isValid() ? fallback : null;
  };

  const handleSetDate = (date, shouldNotify = true) => {
    if (!date) {
      setSelectedDate(null);
      setDateToShow(null);
      setTimeToShow(null);
      setIsDropdownOpen(false);
      handleSetPassedDate(null, null, null, shouldNotify);
      return;
    }

    if (isPersianCalendar) {
      const jalaliDate = getValidJalaliMoment(date);

      if (!jalaliDate) {
        console.warn("Invalid Persian date in DatePickerTemplate:", date);
        return;
      }

      const normalizedDateToPass = jalaliDate.format(OUTPUT_FORMAT);
      const normalizedDateToShow = jalaliDate.format("jYYYY/jMM/jDD");
      const normalizedTimeToShow = jalaliDate.format("HH:mm");

      setSelectedDate(normalizedDateToPass);
      setDateToShow(normalizedDateToShow);
      setTimeToShow(normalizedTimeToShow);
      setIsDropdownOpen(false);

      handleSetPassedDate(
          normalizedDateToPass,
          normalizedDateToShow,
          normalizedTimeToShow,
          shouldNotify
      );

      return;
    }

    const gregorianDate = Moment(date);

    if (!gregorianDate.isValid()) {
      console.warn("Invalid Gregorian date in DatePickerTemplate:", date);
      return;
    }

    const normalizedDateToPass = gregorianDate.format("YYYY-MM-DD HH:mm:ss");
    const normalizedDateToShow = gregorianDate.format("Do, MMMM YYYY");
    const normalizedTimeToShow = gregorianDate.format("HH:mm");

    setSelectedDate(normalizedDateToPass);
    setDateToShow(normalizedDateToShow);
    setTimeToShow(normalizedTimeToShow);
    setIsDropdownOpen(false);

    handleSetPassedDate(
        normalizedDateToPass,
        normalizedDateToShow,
        normalizedTimeToShow,
        shouldNotify
    );
  };

  useEffect(() => {
    if (value) {
      // Restoring a saved value must only hydrate the editor. Treating it as
      // a new user selection causes the partially restored range to overwrite
      // the saved filter when the user returns from another filter menu.
      handleSetDate(value, false);
    } else {
      setDateToShow(null);
      setTimeToShow(null);
      setSelectedDate(null);
      handleSetPassedDate(null, null, null, false);
    }
  }, [value]);

  const context = useContext(appContext);
  const themeColor = context?.handleLayerList()?.find((item) => item.selected)?.color;

  return (
      <div className={styles.DatePickerTemplateWrapper}>
        <div
            onClick={handleToggleOpenDropdown}
            className={`${styles.DatePickerTemplate} ${
                isDropdownOpen && styles.isOpen
            } d-flex align-items-center justify-content-between`}
            style={{ borderColor: isOpen && themeColor && themeColor }}
        >
          <div
              className={`d-flex ${
                  columnLayout ? "flex-column" : "justify-content-center justify-content-center"
              }`}
          >
            <div
                className={`d-flex align-items-center ${
                    !columnLayout ? "justify-content-center" : "ml-1"
                }`}
            >
              <div className={`d-flex ${styles.circle} ${selectedDate && styles.isActive}`}>
                <svg
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="3" cy="3" r="3" fill="#C2C7ED" />
                </svg>
              </div>

              <div className={`${styles.title} d-flex ml-2`}>{type}</div>
            </div>

            <div
                style={{
                  marginLeft: columnLayout && 0,
                  marginTop: columnLayout && 9,
                }}
                className={styles.selectedDate}
            >
              {dateToShow || "Date : -"}
            </div>

            <div
                style={{
                  marginLeft: columnLayout && 0,
                  marginTop: columnLayout && 4,
                  marginBottom: columnLayout && 4,
                }}
                className={`${styles.selectedTime}`}
            >
              {timeToShow || "Time : -"}
            </div>
          </div>

          <div className={`d-flex align-items-center justify-content-center ${styles.arrow}`}>
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M15.8334 7.08333L10.0001 12.9167L4.16675 7.08333"
                  stroke="#0A195C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {isDropdownOpen && (
            <div style={{ marginTop: 12, position: "absolute" }}>
              <Datepicker
                  showInput={false}
                  handleSetDate={handleSetDate}
                  value={selectedDate}
                  dropdownOpenPosition={dropdownOpenPosition}
                  themeColor={themeColor}
              />
            </div>
        )}
      </div>
  );
};

export default DatePickerTemplate;
